<ng-container *transloco="let t; read: 'user'">
  <div class="p-5">
    <drdp-title [title]="t('manageEnrollment.searchManageChild.pageTitle')" [tutorialUrls]="[{url: 'https://youtube.com/watch?v=rE8mmMpdTQ8'}]"></drdp-title>

    <drdp-container additionClasses="h-max">
      <div class="w-full flex flex-col">
        <drdp-container color="lightBlue" additionClasses=" min-h-[7rem] w-full">
          <form
            class="grid grid-cols-1 grid-rows-3 md:grid-cols-3 lg:grid-cols-5 p-2 gap-3 flex-row content-center"
            [formGroup]="childSearch"
            >
            <div class="col-span-1 self-end">
              <label class="font-bold">{{ t('manageEnrollment.searchManageChild.firstNameLabel') }}</label>
              <div class="basis-1/2 border-b border-black">
                <input
                  matInput
                  [placeholder]="t('manageEnrollment.searchManageChild.firstNamePlaceholder')"
                  formControlName="firstName"
                  />
              </div>
            </div>
            <div class="col-span-1 self-end">
              <label class="font-bold">{{ t('manageEnrollment.searchManageChild.lastNameLabel') }}</label>
              <div class="basis-1/2 border-b border-black">
                <input
                  matInput
                  [placeholder]="t('manageEnrollment.searchManageChild.lastNamePlaceholder')"
                  formControlName="lastName"
                  />
              </div>
            </div>
            <div class="col-span-1 self-end">
              <drdp-select-age-grade
                #ageGradeSelectSelect
                [initialageGradeId]="ageGradeInstrumentId.value"
                (ageGrade)="handleDropdown($event, selectType.AgeInstrument)"
                [stateId]="stateId.value"
                [multiSelect]="false"
                [clear]="clearDropdowns"
                [label]="t('manageEnrollment.searchManageChild.ageGradeLabel')"
                [includePilot]="true"
                [schoolYearId]="ratingPeriodId.value ? selectedSchoolYearId : null"
                >
              </drdp-select-age-grade>
            </div>
            <div class="col-span-1 self-end">
              <label class="font-bold">{{ t('manageEnrollment.searchManageChild.drdpIdLabel') }}</label>
              <div class="basis-1/2 border-b border-black">
                <input
                  matInput
                  [placeholder]="t('manageEnrollment.searchManageChild.drdpIdPlaceholder')"
                  formControlName="drdpId"
                  />
              </div>
            </div>
            <div class="col-span-1 self-end">
              <!-- Server-supplied: SSID label comes from the state configuration API. -->
              <label class="font-bold">{{ ssidLabel }}</label>
              <div class="basis-1/2 border-b border-black">
                <input
                  matInput
                  [placeholder]="ssidPlaceholder"
                  formControlName="SSID"
                  />
              </div>
            </div>
            <div class="col-span-1 self-end">
              <label class="font-bold">{{ t('manageEnrollment.searchManageChild.agencyIdLabel') }}</label>
              <div class="basis-1/2 border-b border-black">
                <input
                  matInput
                  [placeholder]="t('manageEnrollment.searchManageChild.agencyIdPlaceholder')"
                  formControlName="localId"
                  />
              </div>
            </div>
            <div #dob class="col-span-1 self-end">
              <drdp-date-picker
                [label]="t('manageEnrollment.searchManageChild.dobLabel')"
                [isReadOnly]="false"
                (emitDate)="handleDate($event)"
                >
              </drdp-date-picker>
            </div>
            <div class="col-span-1 self-end">
              <drdp-select-state
                #stateSelect
                [initialStateId]="stateId?.value"
                (state)="handleDropdown($event, selectType.States)"
                [clear]="clearDropdowns"
                >
              </drdp-select-state>
            </div>
            <div class="col-span-1 self-end">
              <drdp-select-agency
                #agencySelect
                [initialAgencyId]="agencyId.value"
                (agency)="handleDropdown($event, selectType.Agencies)"
                [stateId]="stateId.value"
                [required]="true"
                [clear]="clearDropdowns"
                >
              </drdp-select-agency>
            </div>
            <div class="col-span-1 self-end">
              <drdp-select-site
                (site)="handleDropdown($event, selectType.Sites)"
                [agencyId]="agencyId.value"
                [multiSelect]="true"
                [multiSelectInitVals]="true"
                [initialSiteIds]="siteIds.value"
                [clear]="clearDropdowns"
                [required]="true"
                >
              </drdp-select-site>
            </div>
            <div class="col-span-1 self-end">
              <drdp-select-rating-period
                (ratingPeriod)="handleDropdown($event, selectType.RatingPeriods)"
                [initialRatingPeriodId]="ratingPeriodId.value"
                [agencyId]="agencyId.value"
                [required]="false"
                [clear]="clearDropdowns"
                [omitFutureRps]="true"
                >
              </drdp-select-rating-period>
            </div>
            <div class="col-span-1 self-end">
              <drdp-select-classroom
                (classroom)="handleDropdown($event, selectType.Class)"
                [ratingPeriodId]="ratingPeriodId.value"
                [siteIds]="siteIds.value"
                [required]="false"
                [clear]="clearDropdowns"
                [useClassroomId]="true"
                >
              </drdp-select-classroom>
            </div>
            <div class="col-span-1 xl:col-span-2"></div>
            <div
              class="lg:col-span-2 xl:col-span-1 flex flex-row justify-evenly items-end xl:flex-row xl:justify-evenly xl:items-end"
              >
              <div class="col-span-1">
                <drdp-btn [disabled]="childSearch.invalid" (click)="search()">
                  <span class="px-2">{{ t('manageEnrollment.common.search') }}</span>
                </drdp-btn>
              </div>
              <div class="col-span-1">
                <drdp-btn color="outline" (click)="onClear()"> {{ t('manageEnrollment.common.clear') }} </drdp-btn>
              </div>
            </div>
          </form>
        </drdp-container>
        @if (tableData?.length) {
          <div
            class="grid grid-cols-1 md:grid-cols-6 py-4 gap-2 content-center"
            >
            <div class="col-span-3 self-end">
              <drdp-btn
                color="outline"
                (click)="selectAllStudents()"
                additionalClasses="text-sm"
                >{{ t('manageEnrollment.searchManageChild.selectAll') }}</drdp-btn
                >
              </div>
              <div class="col-span-1 self-end" [matTooltip]="t('manageEnrollment.searchManageChild.transferInfo')" matTooltipPosition="above">
                <div class="text-end">
                  <i class="uil uil-info-circle" style="font-size: 0.8em; vertical-align: middle;"></i>
                </div>
                <drdp-btn additionalClasses="text-sm w-full" (click)="batchTransfer()"
                  >{{ t('manageEnrollment.searchManageChild.transfer') }}
                  </drdp-btn
                  >
                </div>
                <div class="col-span-1 self-end" [matTooltip]="t('manageEnrollment.searchManageChild.reEnrollInfo')" matTooltipPosition="above">
                  <div class="text-end">
                    <i class="uil uil-info-circle" style="font-size: 0.8em; vertical-align: middle;"></i>
                  </div>
                  <drdp-btn additionalClasses="text-sm w-full" (click)="batchReEnroll()"
                    >{{ t('manageEnrollment.searchManageChild.reEnroll') }}
                    </drdp-btn
                    >
                  </div>
                  <div class="col-span-1 self-end" [matTooltip]="t('manageEnrollment.searchManageChild.withdrawInfo')" matTooltipPosition="above">
                    <div class="text-end">
                      <i class="uil uil-info-circle" style="font-size: 0.8em; vertical-align: middle;"></i>
                    </div>
                    <drdp-btn additionalClasses="text-xs w-full" (click)="batchWithdraw()"
                      >{{ t('manageEnrollment.searchManageChild.withdrawFromAgency') }}
                      </drdp-btn
                      >
                    </div>
                  </div>
                }
                <drdp-add-edit-table
                  [dataSource]="dataSource"
                  [tableData]="tableData"
                  [columns]="tableColumns"
                  viewIcon="uil uil-file text-drdpblue-300"
                  (viewActionItem)="openViewChild($event)"
                  (toggleSwitchActionItem)="handleCheckbox($event)"
                  >
                </drdp-add-edit-table>
              </div>
            </drdp-container>

            <mat-paginator
              [pageSizeOptions]="pageSizeOptions"
              [pageSize]="pageSize"
              [length]="totalData"
              [pageIndex]="pageIndex"
              (page)="paginateTable(false)"
              >
            </mat-paginator>
          </div>
</ng-container>
